module.exports = __webpack_public_path__ + "site/img/287.f466397d.jpg";